import styled from "styled-components";

export const RadarImage = styled.img`
  height: 100%;
  width: 100%;
  position: absolute;
  background-repeat: no-repeat;
  background-size: cover;
`;
